var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationBuilding = function SvgSimpleIllustrationBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__building_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".simple-illustration__building_svg__st2{stroke:#002140;stroke-linejoin:round;fill:none}.simple-illustration__building_svg__st4{fill:#002140}"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd7b0",
      strokeLinecap: "round",
      stroke: "#002140",
      strokeLinejoin: "round"
    },
    d: "M23 10h28v48H23z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__building_svg__st4",
    x: 30,
    y: 15,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__building_svg__st4",
    x: 30,
    y: 26,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__building_svg__st4",
    x: 30,
    y: 37,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__building_svg__st4",
    x: 40,
    y: 15,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__building_svg__st4",
    x: 40,
    y: 26,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__building_svg__st4",
    x: 40,
    y: 37,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      stroke: "#002140",
      strokeLinejoin: "round",
      fill: "#ffa75a"
    },
    d: "M15 10h8v48h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8dc8ff",
      strokeLinecap: "round",
      stroke: "#002140",
      strokeLinejoin: "round"
    },
    d: "M29 50h18v8H29z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__building_svg__st2",
    d: "M35 50v8M41 50v8"
  })));
};
export default SvgSimpleIllustrationBuilding;